import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import arrowDown from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Account/icon/arrowDown.png';

export default function ReviewsSorter(props: {
    reviews: any[];
    setReviews: React.Dispatch<React.SetStateAction<any[]>>;
}) {
    const { reviews, setReviews } = props;
    const { t } = useTranslation('templatePages');

    const MOST_RECENT = t('review.sort.most-recent');
    const OLDEST_FIRST = t('review.sort.oldest-first');
    const RATING_HIGH = t('review.sort.rating-high');
    const RATING_LOW = t('review.sort.rating-low');

    const [currentSortCriteria, setCurrentSortCriteria] = useState<string>('');
    const [showSortChoices, setShowSortChoices] = useState<boolean>(false);
    const { currentLocale } = usePageLocalization();

    useEffect(() => {
        setCurrentSortCriteria(t('review.sort.most-recent'));
    }, [currentLocale]);

    const sortBy = (criteria: string) => {
        switch (criteria) {
            case MOST_RECENT:
                return reviews
                    ?.slice()
                    ?.sort(
                        (a, b) =>
                            +new Date(b?.created_at) - +new Date(a?.created_at)
                    );

            case OLDEST_FIRST:
                return reviews
                    ?.slice()
                    ?.sort(
                        (a, b) =>
                            +new Date(a?.created_at) - +new Date(b?.created_at)
                    );

            case RATING_HIGH:
                return reviews
                    ?.slice()
                    ?.sort((a, b) => b?.average_rating - a?.average_rating);

            case RATING_LOW:
                return reviews
                    ?.slice()
                    ?.sort((a, b) => a?.average_rating - b?.average_rating);
            default:
                return reviews;
        }
    };

    useEffect(() => {
        setReviews(sortBy(currentSortCriteria));
    }, [currentSortCriteria]);

    const getClassName = (criteria: string): string => {
        return criteria === currentSortCriteria ? 'selected' : '';
    };

    return (
        <div
            className='sort-menu'
            onClick={() => setShowSortChoices((i) => !i)}
        >
            <div>
                <span>{t('review.sort.sort-by')} :</span>
            </div>
            <div>
                <span className='selected'>{currentSortCriteria}</span>
                <img className='open-sort-menu' src={arrowDown} alt={''} />
                <div
                    className='sort-criteria-list'
                    style={{ display: showSortChoices ? 'block' : 'none' }}
                >
                    <div onClick={() => setCurrentSortCriteria(MOST_RECENT)}>
                        <span className={getClassName(MOST_RECENT)}>
                            {MOST_RECENT}
                        </span>
                    </div>
                    <div onClick={() => setCurrentSortCriteria(OLDEST_FIRST)}>
                        <span className={getClassName(OLDEST_FIRST)}>
                            {OLDEST_FIRST}
                        </span>
                    </div>
                    <div onClick={() => setCurrentSortCriteria(RATING_HIGH)}>
                        <span className={getClassName(RATING_HIGH)}>
                            {RATING_HIGH}
                        </span>
                    </div>
                    <div onClick={() => setCurrentSortCriteria(RATING_LOW)}>
                        <span className={getClassName(RATING_LOW)}>
                            {RATING_LOW}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
